export const AppNationalities=[
    "Afghan",
    "Albanais",
    "Algérien",
    "Américain",
    "Andorran",
    "Angolais",
    "Antiguais",
    "Argentin",
    "Arménien",
    "Australien",
    "Autrichien",
    "Azerbaïdjanais",
    "Bahaméen",
    "Bahreïnien",
    "Bangladeshi",
    "Barbadien",
    "Barbudans",
    "Batswana",
    "Biélorusse",
    "Belge",
    "Bélizien",
    "Béninois",
    "Bhoutanais",
    "Bolivien",
    "Bosniaque",
    "Brésilien",
    "Britanique",
    "Bruneien",
    "Bulgare",
    "Burkinabé",
    "Birman",
    " Burundais ",
    "Cambodgien",
    "Camerounais",
    "Canadien",
    "Capverdien",
    " Centrafricain ",
    "Tchadien",
    "Chilien",
    "Chinois",
    "Colombien",
    " Comorien ",
    " Congolais ",
    "Costaricain",
    "Croate",
    "Cubain",
    "Chypriote",
    "Tchèque",
    "Danois",
    "Djibouti",
    "Dominicain",
    "Néerlandais",
    "Timorais oriental",
    "Équatorien",
    "Égyptien",
    "Émirien",
    "Équato-Guinéen",
    "Érythréen",
    "Estonien",
    "Éthiopien",
    "Fidjien",
    "Philippin",
    "Finlandais",
    "Français",
    "Gabonais",
    "Gambien",
    "Géorgien",
    "Allemand",
    "Ghanéen",
    "Grec",
    "Grenadien",
    "Guatémaltèque",
    "Guinée-Bissauan",
    "Guinéen",
    "Guyanais",
    "Haïtien",
    "Herzégovinien",
    "Hondurien",
    "Hongrois",
    "Je-Kiribati",
    "Islandais",
    "Indien",
    "Indonésien",
    "Iranien",
    "Irakien",
    "Irlandais",
    "Israélien",
    "Italien",
    "Ivoirien",
    "Jamaïquain",
    "Japonais",
    "Jordanien",
    "Kazakhstanais",
    "Kenyan",
    "Kittien et Nevisien",
    "Koweïtien",
    "Kirghize",
    "Laotien",
    "Letton",
    "Libanais",
    "Libérien",
    "Libyen",
    "Liechtensteinois",
    "Lituanien",
    "Luxembourgeois",
    "Macédonien",
    "Malgache",
    "Malawien",
    "Malaisien",
    "Maldivan",
    "Malien",
    "Maltais",
    "Maréchalais",
    "Mauritanien",
    "Mauricien",
    "Mexicain",
    "Micronésien",
    "Moldave",
    "Monaconais",
    "Mongol",
    "Marocain",
    "Mosotho",
    "Mootswanais",
    "Mozambicain",
    "Namibien",
    "Nauruan",
    "Népalais",
    "Néo-Zélandais",
    "Nicaraguayen",
    "Nigérian",
    "Nigérien",
    "Nord coréen",
    "Irlandais du Nord",
    "Norvégien",
    "Omanais",
    "Pakistanais",
    "Palauan",
    "Panaméen",
    "Papouasie-Nouvelle-Guinée",
    "Paraguayen",
    "Péruvien",
    "Polonais",
    "Portugais",
    "Qatariens",
    "Roumain",
    "Russe",
    "Rwandais",
    "Saint Lucien",
    "Salvadorien",
    "Samoan",
    "Saint-Marinais",
    "Sao Toméen",
    "Saoudien",
    "Écossais",
    "Sénégalais",
    "Serbe",
    "Seychellois",
    "Sierra Léonais",
    "Singapourien",
    "Slovaque",
    "Slovène",
    "Insulaire Salomon",
    "Somali",
    "Sud africain",
    "Sud coréen",
    "Espagnol",
    "Sri lankais",
    "Soudanais",
    "Surinam",
    "Swazi",
    "Suédois",
    "Suisse",
    "Syrien",
    "Taïwanais",
    "Tadjik",
    "Tanzanien",
    "Thaïlandais",
    "Togolais",
    "Tongien",
    "Trinidadien ou Tobagonien",
    "Tunisien",
    "Turc",
    "Tuvaluan",
    "Ougandais",
    "Ukrainien",
    "Uruguayen",
    "Ouzbékistanais",
    "Vénézuélien",
    "Vietnamien",
    "Gallois",
    "Yéménite",
    "Zambien",
    "Zimbabwéen"
 ]